var owlTimer = setInterval(function () {
        if ($('.single-product').length && !$('.single-product').hasClass('owl-loaded')) {

          clearInterval(owlTimer); // stop checking

          var mediaListCarousel = $('.product__media-list').owlCarousel({
          nav: true,
          navText: [
            '<i class="fa fa-angle-left"></i>',
            '<i class="fa fa-angle-right"></i>'
          ],
          dots: false,
          loop: false,
          margin: 15,
          rewind: true,
          rtl: rtlFlag,
          center: false, // Ensure only one active item at a time
          responsive: {
            0: {
              items: 3
            },
            544: {
              items: 4
            },
            768: {
              items: 3
            },
            992: {
              items: $('#shopify-section-Ishi_sidebar').length ? 3 : 4
            },
            1200: {
              items: 4
            }
          }
          })

          var rtlFlag = false;
          var fancyboxOpen = false;

          var singleProductCarousel = $('.single-product').owlCarousel({
            nav: true,
            navText: [
              '<i class="fa fa-angle-left"></i>',
              '<i class="fa fa-angle-right"></i>'
            ],
            dots: false,
            loop: false,
            margin: 15,
            items: 1,
            rewind: true,
            rtl: rtlFlag
          }).on('changed.owl.carousel', function (event) {

            if (fancyboxOpen) return;

            var index = event.item.index;

            $('.product__media-list').trigger('to.owl.carousel', [index, 300, true]);
            $('.product__media-list .owl-item').removeClass('active')
              .eq(index).addClass('active');
          });

          // Thumbnail click
          $('.grid__item .product__media-item').on('click', function () {
            var index = $(this).closest('.owl-item').index();
            singleProductCarousel.trigger('to.owl.carousel', [index, 300, true]);
          });

          // Fancybox
          $('[data-fancybox="gallery"]').not('.owl-cloned [data-fancybox]').fancybox({
            beforeShow: function (instance, current) {
              fancyboxOpen = true;
              singleProductCarousel.trigger('to.owl.carousel', [current.index, 0, true]);
            },
            afterShow: function (instance, current) {
              singleProductCarousel.trigger('to.owl.carousel', [current.index, 0, true]);
            },
            afterClose: function () {
              fancyboxOpen = false;
            }
          });

        }
      }, 50);